import { render, staticRenderFns } from "./calendar-event.vue?vue&type=template&id=e3a0b840&scoped=true&"
import script from "./calendar-event.vue?vue&type=script&lang=ts&"
export * from "./calendar-event.vue?vue&type=script&lang=ts&"
import style0 from "./calendar-event.vue?vue&type=style&index=0&id=e3a0b840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a0b840",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
